import "./sw-movie.module.css";
import { html } from "lit-html";
import { LANGUAGE } from "../../global.ts";
import Strings from "../../../models/Strings.json";

const BUDDHA = new URL("../../../public/buddha.webp", import.meta.url).href;

export default (user) => html`
    <div
        id="sw-movie"
        data-modal-backdrop="static"
        tabindex="-1"
        aria-hidden="true"
        class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-70 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
        <div class="relative p-4 w-full max-w-2xl max-h-full">
            <!-- Modal content -->
            <div
                class="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
                <!-- Modal header -->
                <div
                    class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200">
                    <h3
                        id="sw-movie-title"
                        class="text-xl font-semibold text-gray-900 dark:text-white">
                        ${Strings.movie6[LANGUAGE]} -
                        ${Strings.movie1[LANGUAGE]}
                    </h3>
                    <div>
                        <button
                            onclick="heartbank.alertAdmin('movie/click/download')"
                            title="${Strings.movie7[LANGUAGE]}"
                            id="sw-movie-download"
                            class="hidden mr-2 text-lg">
                            📥
                        </button>
                        <button
                            onclick="heartbank.alertAdmin('movie/click/pause')"
                            title="${Strings.movie11[LANGUAGE]}"
                            id="sw-movie-pause"
                            class="hidden mr-2 text-lg">
                            ⏸️
                        </button>
                        <button
                            onclick="heartbank.alertAdmin('movie/click/trash')"
                            title="${Strings.movie12[LANGUAGE]}"
                            id="sw-movie-trash"
                            class="hidden ml-2 mr-2 text-lg">
                            🗑️
                        </button>
                        <button
                            title="${Strings.close[LANGUAGE]}"
                            type="button"
                            class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                            data-modal-hide="sw-movie">
                            <svg
                                class="w-3 h-3"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 14 14">
                                <path
                                    stroke="currentColor"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                            </svg>
                            <span class="sr-only"
                                >${Strings.close[LANGUAGE]}</span
                            >
                        </button>
                    </div>
                </div>
                <!-- Modal body -->
                <div>
                    <aside id="sw-movie-status" class="hidden relative w-full">
                        <progress
                            id="sw-movie-bar"
                            value="0"
                            max="100"
                            class="w-full h-5"></progress>
                        <p
                            id="sw-movie-progress"
                            class="absolute w-full text-center mt-[-2px] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-base font-bold text-white dark:text-white">
                            0%
                        </p>
                    </aside>
                    <video
                        controls
                        playsinline
                        poster="${BUDDHA}"
                        id="sw-movie-video"
                        class="w-full"></video>
                    <section id="sw-movie-container" class="hidden">
                        <div
                            id="sw-movie-iframe"
                            class="border-none w-full"
                            title="${Strings.movie6[LANGUAGE]}"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerpolicy="strict-origin-when-cross-origin"
                            allowfullscreen></div>
                    </section>
                </div>
                <!-- Modal footer -->
                <div
                    class="flex items-center justify-around p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">
                    <button
                        onclick2="heartbank.alertAdmin('movie/click/${Strings
                            .previous[LANGUAGE]}')"
                        id="sw-movie-prev"
                        type="button"
                        class="hidden text-white w-32 bg-theme hover:bg-theme/25 focus:ring-4 focus:outline-none focus:ring-theme/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-theme dark:hover:bg-theme/50 dark:focus:ring-theme/10">
                        ← ${Strings.movie1[LANGUAGE]}
                    </button>
                    <button
                        onclick2="heartbank.alertAdmin('movie/click/${Strings
                            .next[LANGUAGE]}')"
                        id="sw-movie-next"
                        type="button"
                        class="hidden text-white w-32 bg-theme hover:bg-theme/25 focus:ring-4 focus:outline-none focus:ring-theme/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-theme dark:hover:bg-theme/50 dark:focus:ring-theme/10">
                        ${Strings.movie2[LANGUAGE]} →
                    </button>
                </div>
            </div>
        </div>
    </div>
`;
